module.exports = __webpack_public_path__ + "static/media/google.745d388e.svg";